import { TableHead, TableTitle } from '@genial/components';

import { columnWidthsDesktop } from '../constants';

export const Head = () => {
  return (
    <TableHead testId="header">
      <TableTitle textAlign="start" width={columnWidthsDesktop.info} testId="header-icon">
        Info
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.name} testId="header-id">
        Nome
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={columnWidthsDesktop.requester}
        testId="header-month-competence">
        Solicitante
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.channel} testId="header-type">
        Canal
      </TableTitle>
      <TableTitle
        textAlign="start"
        width={columnWidthsDesktop.blockingDate}
        testId="header-billed-customers">
        Data de bloqueio
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.status} testId="header-send-date">
        Status
      </TableTitle>
      <TableTitle textAlign="start" width={columnWidthsDesktop.confirm} testId="header-total" />
    </TableHead>
  );
};
